import Vue from 'vue';
import Router from 'vue-router';
import { routes } from '../app';

Vue.use(Router);

var router = new Router({
    routes: routes
});
router.beforeEach((to, from, next) => {
    if (to.meta.admin && !Vue.prototype.$isAdmin) {
        next('/');
    } else {
        next();
    }
});
export default router


// WEBPACK FOOTER //
// ./ClientApp/router/index.js